import { Alert as AntAlert, Button as CloseButton, Typography } from "antd";
import {
	ButtonWrapper,
	TextCol,
	Wrapper,
} from "../../mobile/screens/LoginModal/styles";

import { Form } from "views/components/common/Form";
import { LoginModal as Modal } from "../../mobile/components/Popup/LoginModal";
import { ModalButton } from "../ModalButton";
import { Spacer } from "views/components/common/Spacer";
import { ToggleTemporary } from "views/mobile/components/Toggle";
import { none, pathOr } from "ramda";
import { useGlobal } from "reactn";
import { useRecaptcha } from "hooks/useRecaptcha";
import { useTemporaryUser } from "hooks/useTemporaryUser";
import Input from "views/components/common/Input/Input";
import ReCAPTCHA from "react-google-recaptcha";
import React, { useEffect, useRef, useState } from "reactn";
import Recaptcha from "react-recaptcha";
import config from "config";
import { useAuth } from "hooks/useAuth";
import { useUpdateUserInfo } from "state/users/hooks";
import { validateDni, validateRut } from "lib/helpers/documents";
import ErrorLabel from "../common/ErrorLabel/ErrorLabel";
import rut from "lib/rut";
const { recaptchaKey } = config;
const { Text } = Typography;

export const ReservationDocumentModal = ({
	blockreservation,
	documentModalType,
	getReservation,
	handleMeet,
	handlerReservation,
	isDni,
	isDniRequired,
	isRutRequired,
	onClose,
	reservationPayload,
	setIsRutUpdating,
	setTemporaryDni,
	setTemporaryRut,
	setWantTemporary,
	temporaryDni,
	temporaryRut,
	visible,
}) => {
	const { isLoggedIn, isLoggedInTemporary } = useAuth();
	const [disabledButton, setDisabledButton] = useState(true);
	const [errorLabel, setErrorLabel] = useState(false);
	const [updateUserData, isLoading] = useUpdateUserInfo();
	const [login, success, loading, error] = useTemporaryUser(
		onClose,
		getReservation,
		blockreservation,
		handleMeet
	);

	const needsToUpdateDocument = isDniRequired || isRutRequired;

	const { loading: reCaptchaLoading } = useRecaptcha(login, refCaptcha);
	const refCaptcha = useRef();

	const onChangeInputs = ({ target, input, value }) => {
		setDisabledButton(true);
		if (input === "rut" && !validateRut(value)) {
			return setErrorLabel("Ingrese un rut válido");
		}

		if (input === "dni" && !validateDni(value)) {
			return setErrorLabel("Ingrese un dni válido");
		}
		setDisabledButton(false);
		setErrorLabel("");
		return isDni ? setTemporaryDni(value) : setTemporaryRut(value);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		onClose();
		if (isLoggedInTemporary && needsToUpdateDocument) {
			return isDni
				? login({ dni: temporaryDni })
				: login({ rut: temporaryRut });
		}

		if (isLoggedIn && needsToUpdateDocument) {
			await updateUserData({
				[documentModalType]: isDni ? temporaryDni : temporaryRut,
			});
			//FIX THIS
			setTimeout(() => handlerReservation(reservationPayload), 1000);
		}

		if (!isLoggedIn && needsToUpdateDocument) {
			setWantTemporary(true);
		}
	};

	return (
		<Modal visible={visible} onCancel={onClose}>
			<Wrapper>
				<TextCol>
					<Text className="modal__text-welcome" type="secondary">
						Necesitaremos algunos datos
					</Text>
					<Text className="modal__text-welcome" type="secondary">
						para hacer tu reserva
					</Text>
					<Spacer rows={1} />
					<Text className="modal__text-welcome_alert">
						Complete todos los campos para continuar.
					</Text>
				</TextCol>
				<Spacer rows={1} />
				<Form className="form__login-modal">
					<div className="input__phone-container">
						<Input
							type={documentModalType}
							name={documentModalType}
							label={
								documentModalType &&
								documentModalType.toUpperCase()
							}
							onChange={onChangeInputs}
							isRut={isRutRequired}
						></Input>
					</div>

					{ErrorLabel && (
						<span className={"error__label-temporary"}>
							{errorLabel}
						</span>
					)}
					<Spacer rows={1} />
					<ButtonWrapper>
						<ModalButton
							onClick={handleSubmit}
							loading={loading || reCaptchaLoading}
							type={"primary"}
							label="Reservar"
							disabled={loading || errorLabel || disabledButton}
						/>
					</ButtonWrapper>
					<ReCAPTCHA
						hl={"es-419"}
						ref={refCaptcha}
						sitekey={recaptchaKey}
						size={"invisible"}
					/>
				</Form>
			</Wrapper>
		</Modal>
	);
};
